import styled from "styled-components";
import {device} from "../helper/constants";

const Wrapper = styled.div`
    width: 200px;
    border: 2px solid #E4E4F4;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media ${device.mobile} {
        width: 130px;
    }
`;

const ButtonMinus = styled.span`
    width: 24px;
    height: 24px;
    background-color: #144344;
    font-size: 20px;
    color: #fff;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px;
    margin-left: 10px;
    cursor: pointer;
  
    &.disabled {
      opacity: 0.2;
      cursor: not-allowed;
    }
`;
const ButtonPlus = styled.span`
    width: 24px;
    height: 24px;
    background-color: #144344;
    font-size: 20px;
    color: #fff;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px;
    margin-right: 10px;
    cursor: pointer;
`;
const QuantityInput = styled.input`
    height: 44px;
    width: 44px;
    background-color: transparent;
    border: none !important;
    text-align: center;
  
    &:focus,
    &:focus-visible {
      border: none !important;
    }
  
`;
export default function ProductQuantityButton({quantity, handleChange}) {

    const handleInputChange = (e) => {
        handleChange(e.target.value);
    }

    const handlePlusBtnClicked = () => {
        handleChange(quantity + 1);
    }
    const handleMinusBtnClicked = () => {
        if (quantity >1) {
            handleChange(quantity - 1);
        }
    }
    return (
        <Wrapper>
            <ButtonMinus onClick={handleMinusBtnClicked} className={quantity === 1 ? 'disabled' : ''}> - </ButtonMinus>
            <QuantityInput value={quantity} onChange={handleInputChange} />
            <ButtonPlus onClick={handlePlusBtnClicked}> + </ButtonPlus>
        </Wrapper>
    );
}